import React from 'react';
import classNames from 'classnames';
import { WHITE, BLACK, WHITE_KING, BLACK_KING } from './consts';

type TPiece = typeof WHITE | typeof BLACK | typeof WHITE_KING | typeof BLACK_KING;

interface IPiece {
  left: number;
  top: number;
  style?: React.CSSProperties;
  onClick: () => void;
  domRef: any;
  piece: TPiece;
  selected: boolean;
}

const Piece: React.FC<IPiece> = ({
  left,
  top,
  style,
  onClick,
  domRef,
  piece,
  selected,
}) => {

  return (
    <div
      onClick={onClick}
      ref={domRef}
      style={{
        left: left + '%',
        top: top + '%',
        ...style,
      }}
      className={classNames('piece', {
        white: piece === WHITE || piece === WHITE_KING,
        black: piece === BLACK || piece === BLACK_KING,
        king: piece === WHITE_KING || piece === BLACK_KING,
        selected: selected,
      })}
    >
      <span />
    </div>
  );
};

export default Piece;
